import { defineStore } from "pinia";

export const useNotificationsStore = defineStore({
  id: "notifications",
  state: () => ({
    notifications: [],
  }),
  getters: {},
  actions: {
    createNotify(message, type, maxWidth = 400, title = "") {
      this.notifications.push({
        message: message,
        maxWidth: maxWidth,
        type: type,
        title: title,
        color: type === "success" ? "green" : "red",
        lifeTime: type === "success" ? 2000 : 5000
      });
    }
  },
});
